module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-right.7481b1b0.svg";